export default "__VITE_ASSET__BCWeEE4x__"